import React, { useState } from 'react';
import { formatCurrency } from '@shared/formatCurrency';
import { ModeledSavingsSlideOut } from '../ModeledSavingsSlideOut';

interface QuoteDiscountSavingsDisplayProps {
  discountSavings?: number;
  discountPolicyType?: number;
  policyType?: number;
  className?: string;
  carrierName?: string;
  annualHealthcareInflationRate?: number;
}

/**
 * Reusable component for displaying discount savings information
 * Used in quote cards to show the additional savings from discounts
 */
export function QuoteDiscountSavingsDisplay({
  discountSavings,
  discountPolicyType,
  policyType,
  className = 'mr-8',
  carrierName,
  annualHealthcareInflationRate,
}: QuoteDiscountSavingsDisplayProps) {
  const [isSlideOutOpen, setIsSlideOutOpen] = useState(false);
  // Only render if we have discount savings and policy types match
  const shouldShowSavings =
    discountSavings !== undefined &&
    discountSavings > 0 &&
    discountPolicyType !== undefined &&
    policyType !== undefined &&
    discountPolicyType === policyType;

  if (!shouldShowSavings) {
    return null;
  }

  const handleSavingsClick = () => {
    setIsSlideOutOpen(true);
  };

  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      <div className="text-primary-dark text-sm font-medium">Modeled Savings</div>
      <button
        type="button"
        onClick={e => {
          e.stopPropagation();
          handleSavingsClick();
        }}
        className="text-primary-dark hover:text-primary-dark/80 flex cursor-pointer items-center gap-1 text-base font-semibold underline decoration-dotted decoration-1 underline-offset-2 transition-colors sm:text-lg"
      >
        {formatCurrency(discountSavings)}
      </button>

      <ModeledSavingsSlideOut
        open={isSlideOutOpen}
        onClose={() => setIsSlideOutOpen(false)}
        carrierName={carrierName}
        annualHealthcareInflationRate={annualHealthcareInflationRate}
      />
    </div>
  );
}
